import { render, staticRenderFns } from "./elUploads.vue?vue&type=template&id=66aa10ee&scoped=true"
import script from "./elUploads.vue?vue&type=script&lang=js"
export * from "./elUploads.vue?vue&type=script&lang=js"
import style0 from "./elUploads.vue?vue&type=style&index=0&id=66aa10ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa10ee",
  null
  
)

export default component.exports